import { render, staticRenderFns } from "./SelectCandidateTable.vue?vue&type=template&id=4b208f98"
import script from "./SelectCandidateTable.vue?vue&type=script&lang=js"
export * from "./SelectCandidateTable.vue?vue&type=script&lang=js"
import style0 from "./SelectCandidateTable.vue?vue&type=style&index=0&id=4b208f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDataFooter,VDataTable,VTextField})
